import { toAbsoluteUrl } from "@/navigation/absoluteUrl";
import type { AppLocationCodec } from "@/navigation/appLocation";
import { NAV_KEYS } from "@/navigation/keys";

export type LeadsListLocation = {
  focus?: string;
};

function readString(params: Record<string, string | undefined>, key: string): string | undefined {
  return params[key]?.trim() || undefined;
}

function normalize(loc: LeadsListLocation): LeadsListLocation {
  const next: LeadsListLocation = {};
  if (loc.focus) next.focus = loc.focus;
  return next;
}

function fromParams(params: Record<string, string | undefined>): LeadsListLocation {
  const loc: LeadsListLocation = {};
  const focus = readString(params, NAV_KEYS.focus);
  if (focus) loc.focus = focus;
  return normalize(loc);
}

function fromUrl(pathname: string, searchParams: URLSearchParams): LeadsListLocation {
  return fromParams(Object.fromEntries(searchParams));
}

function toParams(loc: LeadsListLocation): Record<string, string> {
  const n = normalize(loc);
  const out: Record<string, string> = {};
  if (n.focus) out[NAV_KEYS.focus] = n.focus;
  return out;
}

function toUrl(loc: LeadsListLocation): string {
  const qs = new URLSearchParams(toParams(loc)).toString();
  return `/leads${qs ? `?${qs}` : ""}`;
}

export const leadsListCodec: AppLocationCodec<LeadsListLocation> = {
  appId: "leads",
  fromUrl,
  fromParams,
  toParams,
  toUrl,
};

export function leadsListShareUrl(loc: LeadsListLocation): string {
  return toAbsoluteUrl(leadsListCodec.toUrl(loc));
}
